import { useEffect } from 'react';

import { getLastViewedContent, clearLastViewedContent } from '../../stores/last-viewed-content';

const PostLoginRedirect = () => {
  useEffect(() => {
    const lastViewedAcademyContent = getLastViewedContent();
    if (lastViewedAcademyContent) {
      clearLastViewedContent();
      const url = new URL(window.location.href);
      url.pathname = lastViewedAcademyContent;
      window.location.href = url.toString();
    }
  }, []);

  return null;
};

export default PostLoginRedirect;
